import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client'
import { withLDProvider } from 'launchdarkly-react-client-sdk'

import App from './Containers/App'
import 'bootstrap/dist/css/bootstrap.min.css'
import './Global/debug-no-focus-outline.css'
import { BrowserRouter } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import ApolloWrapper from './AuthApolloProvider'
import { loadSegment } from './Global/segmentLoader'

// Suppress React Bootstrap findDOMNode warnings
// TODO: Remove this when React Bootstrap updates to use React 18
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error
  console.error = (...args) => {
    if (/Warning.*findDOMNode/.test(args[0])) return
    originalError(...args)
  }

  const originalWarn = console.warn
  console.warn = (...args) => {
    if (/findDOMNode/.test(args[0])) return
    originalWarn(...args)
  }
}
// end

let AppWithLaunchDarkly = withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_KEY,
  user: {
    key: 'anonymous-user', // Use the consistent anonymous key
    anonymous: true, // Mark as anonymous
  },
  // Disable event sending for anonymous users on DEV and TEST environments
  // options: {
  //   sendEvents: false, // Disable event sending for anonymous users
  //   streaming: false, // Disable streaming for anonymous users
  // },
})(App)

loadSegment()

const root = createRoot(document.getElementById('root'))

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Auth0Provider
        clientId={process.env.REACT_APP_AUTH0_APP_CLIENT_ID}
        domain={process.env.REACT_APP_AUTH0_CUSTOM_DOMAIN}
        authorizationParams={{
          redirect_uri: window.location.origin + '/my-loan',
        }}
        onRedirectCallback={(appState) => {
          const cleanCurrentUrl = new URL(window.location.href)
          ;[
            'code',
            'state',
            'error',
            'error_description',
          ].forEach((param) => cleanCurrentUrl.searchParams.delete(param))

          const fallbackPath = `${cleanCurrentUrl.pathname}${cleanCurrentUrl.search}${cleanCurrentUrl.hash}`
          const targetUrl = appState?.targetUrl || fallbackPath || '/my-loan'

          window.history.replaceState(
            {},
            document.title,
            targetUrl,
          )
        }}
        cacheLocation="localstorage"
      >
        <ApolloWrapper>
          <AppWithLaunchDarkly />
        </ApolloWrapper>
      </Auth0Provider>
    </BrowserRouter>
  </HelmetProvider>,
)
